import api from 'axios'
import { URL_BACK } from '../../viariableProd'
const pathGet = URL_BACK + '/getElearning.php'
const pathsetAnswer = URL_BACK + '/setAnswerElearning.php'
const pathResult = URL_BACK + '/getResultElearning.php'
const pathgetAnswer = URL_BACK + '/getAnswersElearning.php'
const pathGetButtons = URL_BACK + '/getImages.php'
export default {
  getData (subnet) {
    return new Promise((resolve, reject) => {
      api
        .post(pathGet + '?subnet=' + subnet)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setAnswer (subnet, credentials) {
    return new Promise((resolve, reject) => {
      api
        .post(pathsetAnswer + '?subnet=' + subnet, credentials)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setAnswerExamen (subnet, credentials) {
    return new Promise((resolve, reject) => {
      api
        .post(pathsetAnswer + '?m=ex&subnet=' + subnet, credentials)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAnswerElearning (subnet, credentials) {
    return new Promise((resolve, reject) => {
      api
        .post(pathgetAnswer + '?id=' + credentials + '&subnet=' + subnet, credentials)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getImages (subnet, credentials) {
    const url = pathGetButtons + '?type=' + credentials + '&subnet=' + subnet
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAnswerUser (subnet, credentials) {
    return new Promise((resolve, reject) => {
      api
        .post(pathResult + '?id=' + credentials.email + '&subnet=' + subnet, credentials)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/elearning.js